import React, {forwardRef, useEffect, useImperativeHandle, useMemo, memo} from "../../../../../__snowpack__/pkg/react.js";
import {Collapse, Form, Col, Row} from "../../../../../__snowpack__/pkg/antd.js";
import styled from "../../../../../__snowpack__/pkg/styled-components.js";
import {useIntl} from "../../../../../__snowpack__/pkg/react-intl.js";
import {IconDown} from "../../../../../__snowpack__/pkg/@genieui-react/icon.js";
import VideoUpload from "../../../../components/VideoUpload.js";
import ImageUpload from "./components/ImageUpload.js";
import {Tip} from "../../../../components/Tip/index.js";
import {Tip as WhiteTip} from "../../../../components/Tip/white.js";
import {isEmpty} from "../../../../../__snowpack__/pkg/lodash.js";
import {
  useVariationOptionsModel,
  useShopCountryModel,
  useCategoryRuleChannelModel
} from "../../store.js";
import GnUpload from "../../../../components/GnUpload/index.js";
import {PlusOutlined} from "../../../../../__snowpack__/pkg/@ant-design/icons.js";
const {Panel} = Collapse;
const extname = (url = "") => {
  const temp = url.split("/");
  const filename = temp[temp.length - 1];
  const filenameWithoutSuffix = filename.split(/#|\?/)[0];
  return (/\.[^./\\]*$/.exec(filenameWithoutSuffix) || [""])[0];
};
const isImageFileType = (type) => type.indexOf("image/") === 0;
export const isImageUrl = (file) => {
  if (file.type) {
    return isImageFileType(file.type);
  }
  const url = file.thumbUrl || file.url;
  const extension = extname(url);
  if (/^data:image\//.test(url) || /(webp|svg|png|gif|jpg|jpeg|jfif|bmp|dpg|ico|image)$/i.test(extension)) {
    return true;
  }
  if (/^data:/.test(url)) {
    return false;
  }
  if (extension) {
    return false;
  }
  return true;
};
const MediaInfo = memo(forwardRef((props, ref) => {
  const {handleStatus, infoData = {}} = props;
  const {formatMessage} = useIntl();
  const [form] = Form.useForm();
  const {variationOptions = []} = useVariationOptionsModel();
  const {shopId} = useShopCountryModel();
  const [firstOptions] = variationOptions;
  const {options = [], variationTypeData} = firstOptions || {};
  const {categoryRuleChannel} = useCategoryRuleChannelModel();
  const {tiktokSupportSizeChart = false, isSizeChartMandatory = false} = categoryRuleChannel || {};
  const getOption = useMemo(() => {
    return options?.filter((data) => data !== "undefined");
  }, [options]);
  useImperativeHandle(ref, () => ({
    submit: async () => {
      try {
        const formValues = await form.validateFields() || {};
        const {variationImages = {}, mainImageList = [], sizeChart: formSizeChart = []} = formValues;
        const [sizeData = {}] = formSizeChart;
        const {response = {}, imgData = {}} = sizeData;
        const sizeChart = {
          id: response?.fileId || imgData?.id,
          url: response?.fileUrl || imgData.url
        };
        const optionImageInfoList = [];
        for (const optionValue in variationImages) {
          const imageData = variationImages[optionValue] || [];
          const activeData = imageData[0] || {};
          const {response: response2 = {}, imgData: imgData2 = {}} = activeData;
          const optionName = variationTypeData?.label;
          if (response2?.fileUrl || imgData2?.url) {
            optionImageInfoList.push({
              optionName,
              optionValue,
              imageInfo: {
                id: response2?.fileId || imgData2?.id,
                url: response2?.fileUrl || imgData2.url
              }
            });
          }
        }
        const videoUrl = formValues.videoUrl?.filter((data) => {
          return data.status === "done";
        })?.map((data) => {
          return {
            videoId: data?.response?.fileId || data?.uid,
            videoUrl: data?.response?.fileUrl || data.url
          };
        });
        const values = {
          optionImageInfoList,
          mainImageList,
          sizeChart,
          attributes: {
            video: {
              ...videoUrl[0]
            }
          }
        };
        return values;
      } catch (error) {
        throw {
          error,
          form
        };
      }
    },
    reset: () => {
      form.resetFields();
    }
  }));
  useEffect(() => {
    if (!isEmpty(infoData)) {
      const {optionImageInfoList = [], mainImageList = [], sizeChart = {}, attributes} = infoData;
      const variationImages = {};
      optionImageInfoList.forEach((item) => {
        const {imageInfo = {}, optionValue} = item;
        const {url: url2} = imageInfo;
        if (url2) {
          variationImages[optionValue] = [
            {
              uid: url2,
              url: url2,
              status: "done",
              response: url2,
              imgData: imageInfo
            }
          ];
        }
      });
      let videoList = [];
      if (attributes?.video?.videoUrl) {
        videoList = [
          {
            uid: attributes?.video?.videoId,
            url: attributes?.video?.videoUrl,
            status: "done",
            response: attributes?.video?.videoUrl,
            imgData: attributes?.video?.videoId
          }
        ];
      }
      const {url} = sizeChart;
      const formSizeChart = url ? [
        {
          uid: url,
          url,
          status: "done",
          response: url,
          imgData: sizeChart
        }
      ] : [];
      setTimeout(() => {
        form.setFieldsValue({
          variationImages,
          mainImageList,
          sizeChart: formSizeChart,
          videoUrl: videoList
        });
      }, 0);
    }
  }, [infoData]);
  const VideoTipMsg = () => {
    return /* @__PURE__ */ React.createElement(VideoTipMsgWrapper, {
      style: {maxWidth: 382, fontSize: 12, color: "#606C80"}
    }, /* @__PURE__ */ React.createElement("p", null, formatMessage({id: "tiktokRequired"})), /* @__PURE__ */ React.createElement("p", {
      style: {margin: 0}
    }, formatMessage({id: "ifYouUploadAVideoIt"})), /* @__PURE__ */ React.createElement("p", null, formatMessage({id: "recommendedRatioIsAndRecommended"})), /* @__PURE__ */ React.createElement("p", null, formatMessage({id: "weRecommendTheVideoDurationIs"})), /* @__PURE__ */ React.createElement("p", null, formatMessage({id: "tryHighlightingCoreSellingPoints"})));
  };
  return /* @__PURE__ */ React.createElement(Wrapper, {
    id: "mediaInfo",
    className: "block-info"
  }, /* @__PURE__ */ React.createElement(Collapse, {
    defaultActiveKey: ["1"],
    expandIconPosition: "right",
    expandIcon: ({isActive}) => /* @__PURE__ */ React.createElement(IconDown, {
      style: {
        transition: "all, 0.3s",
        position: "absolute",
        top: 10,
        transform: `rotate(
                  ${isActive ? 0 : "-90deg"}
              )`
      }
    })
  }, /* @__PURE__ */ React.createElement(Panel, {
    header: /* @__PURE__ */ React.createElement("div", {
      className: "block-title"
    }, formatMessage({id: "mediaSettings"})),
    key: "1"
  }, /* @__PURE__ */ React.createElement("div", {
    style: {display: shopId ? "block" : "none"}
  }, /* @__PURE__ */ React.createElement(Form, {
    layout: "vertical",
    form
  }, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, {
    span: "24"
  }, /* @__PURE__ */ React.createElement(Form.Item, {
    label: /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("span", null, formatMessage({id: "theRangeOfProductImagesThat"}, {min: 1, max: 9})), /* @__PURE__ */ React.createElement(Tip, {
      tip: formatMessage({
        id: "apiLimitationMaxSizeMb"
      })
    })),
    name: "mainImageList",
    validateFirst: true,
    rules: [
      GnUpload.basicFormRule,
      {
        required: ["PUBLISH"].includes(handleStatus),
        message: formatMessage({id: "isRequired"})
      },
      {
        type: "array",
        min: 1,
        max: 9,
        message: formatMessage({id: "theRangeOfProductImagesThat"}, {min: 1, max: 9})
      }
    ],
    valuePropName: "fileList",
    getValueFromEvent: ({fileList = []}) => fileList
  }, /* @__PURE__ */ React.createElement(GnUpload, {
    name: "file",
    action: "/saas/product/v2/upload/upload-file",
    accept: "image/jpeg,image/png,image/jpg",
    listType: "picture-card",
    draggable: true,
    maxCount: 9,
    maxSize: 5 * 1024 * 1024,
    resolution: {minHeight: 600, minWidth: 600, maxHeight: 2e4, maxWidth: 2e4, ratio: "1:1"},
    data: {
      fileType: "PRODUCT_IMAGE",
      channel: "TIKTOK_ID",
      shopId
    },
    parseResponse: (response) => ({
      id: response?.data?.fileId,
      url: response?.data?.fileUrl
    }),
    dataShape: {
      url: "url",
      id: "id"
    }
  }, /* @__PURE__ */ React.createElement(PlusOutlined, {
    style: {fontSize: 20, color: "#7F8FA4"}
  }))))), getOption.length > 0 && /* @__PURE__ */ React.createElement(Form.Item, {
    label: formatMessage({
      id: "variantImage"
    }),
    shouldUpdate: true
  }, ({getFieldValue}) => {
    const variationImages = getFieldValue("variationImages") || {};
    const optionImages = [];
    getOption.forEach((name) => {
      const activeFormData = variationImages[name] || [];
      if (activeFormData[0]?.status == "done") {
        optionImages.push(name);
      }
    });
    const variatioImageLength = optionImages?.length;
    return /* @__PURE__ */ React.createElement(Form.Item, {
      name: "_validator",
      rules: [
        {
          required: true,
          validator: (rule, value) => {
            if (variatioImageLength > 0) {
              if (variatioImageLength != getOption?.length) {
                return Promise.reject(formatMessage({id: "youMustAddAllTheVariation"}));
              }
            }
            return Promise.resolve();
          }
        }
      ]
    }, /* @__PURE__ */ React.createElement(Row, null, getOption.map((_, index) => {
      return /* @__PURE__ */ React.createElement("div", {
        className: "variant-image-item",
        key: index
      }, /* @__PURE__ */ React.createElement(Form.Item, {
        name: ["variationImages", _]
      }, /* @__PURE__ */ React.createElement(ImageUpload, {
        onChange: () => {
          form.validateFields(["_validator"]);
        },
        limitNum: 1,
        limitSizeM: 5,
        limitWH: [600, 600],
        limitMaxWH: [2e4, 2e4],
        limitRatio: 1,
        invalidSizeMsg: formatMessage({
          id: "pictureSizeCannotExceedM"
        }),
        invalidWhMsg: formatMessage({
          id: "imageMustBePxpx"
        }),
        invalidRatioMsg: formatMessage({
          id: "onlySupportsImages"
        }),
        requiredLabel: () => {
          return _;
        },
        itemTitleRender: () => {
          return _;
        },
        uploadProps: {
          isImageUrl,
          data: {
            fileType: "ATTRIBUTE_IMAGE",
            channel: "TIKTOK_ID",
            shopId
          },
          multiple: false
        }
      })));
    })));
  }), tiktokSupportSizeChart && /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Form.Item, {
    label: /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("span", null, formatMessage({
      id: "sizeChart"
    })), /* @__PURE__ */ React.createElement(Tip, {
      tip: formatMessage({
        id: "apiLimitationMaxSizeMb"
      })
    })),
    name: "sizeChart",
    initialValue: [],
    rules: [
      {
        required: ["PUBLISH"].includes(handleStatus) ? isSizeChartMandatory : false,
        message: formatMessage({
          id: "pleaseUploadASizePicture"
        })
      }
    ]
  }, /* @__PURE__ */ React.createElement(ImageUpload, {
    limitNum: 1,
    limitSizeM: 5,
    limitWH: [600, 600],
    limitMaxWH: [2e4, 2e4],
    invalidSizeMsg: formatMessage({
      id: "apiLimitationMaxSizeMb"
    }),
    invalidWhMsg: formatMessage({
      id: "apiLimitationMaxSizeMb"
    }),
    uploadProps: {
      isImageUrl,
      data: {
        fileType: "SIZE_CHART_IMAGE",
        channel: "TIKTOK_ID",
        shopId
      },
      multiple: false
    }
  }))), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Form.Item, {
    label: /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("span", null, formatMessage({
      id: "video"
    })), /* @__PURE__ */ React.createElement(WhiteTip, {
      tip: /* @__PURE__ */ React.createElement(VideoTipMsg, null)
    })),
    name: "videoUrl",
    initialValue: []
  }, /* @__PURE__ */ React.createElement(VideoUpload, {
    limitNum: 1,
    limitSizeM: 20,
    limitMaxWH: [2e4, 2e4],
    invalidSizeMsg: formatMessage({
      id: "ifYouUploadAVideoIt"
    }),
    invalidWhMsg: formatMessage({
      id: "ifYouUploadAVideoIt"
    }),
    uploadProps: {
      isImageUrl,
      data: {
        fileType: "CERTIFICATION_IMAGE",
        channel: "TIKTOK_ID",
        shopId
      },
      multiple: false
    }
  }))))), /* @__PURE__ */ React.createElement("div", {
    style: {display: shopId ? "none" : "block"}
  }, formatMessage({id: "chooseTheStoreFirstPlease"})))));
}));
export default MediaInfo;
const Wrapper = styled.div`
  &.block-info {
    background: #ffffff;
  }
  .block-title {
    font-size: 14px;
    font-family: SFProText-Medium, SFProText;
    font-weight: 500;
    color: #161344;
    line-height: 20px;
  }
  .ant-collapse {
    border: 1px solid #dfe3e8;
    background: #fff;
    border-radius: 0;
  }
  .ant-collapse > .ant-collapse-item {
    border-bottom: 0;
  }
  .ant-collapse-content {
    border-top: 1px solid #dfe3e8;
  }
  .ant-form-item {
    margin-bottom: 16px;
  }
  .variant-image-item {
    margin-right: 8px;
    margin-bottom: 8px;
  }
  .variant-image-item + .variant-image-item {
    .ant-form-item-label {
      opacity: 0;
    }
  }
  .uploader-with-modal-title {
    text-align: center;
    font-size: 12px;
    font-family: SFProText-Regular, SFProText;
    font-weight: 400;
    color: #7f8fa4;
    line-height: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
const VideoTipMsgWrapper = styled.div`
  max-width: 382px;
  font-size: 12px;
  line-height: 24px;
  p {
    margin-bottom: 0;
  }
`;
